import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetSurveyParticipantsTerminateds = surveyId => {
  const query = useApiQuery(
    ['participantsTerminated', surveyId],
    'sociogram',
    `/participants-terminateds?surveyId=${surveyId}`,
    { enabled: !!surveyId }
  )

  return {
    isLoadingParticipantsTerminated: query.isLoading,
    isFetchingParticipantsTerminated: query.isFetching,
    participantsTerminated: query.data ?? [],
    errorParticipantsTerminated: query.isError ? query.error : null,
    getParticipants: query.refetch
  }
}
